/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.inbox.ResolvedBy
*/
export var ResolvedBy;
(function (ResolvedBy) {
    ResolvedBy["USER"] = "USER";
    ResolvedBy["AUTO_DEFAULT"] = "AUTO_DEFAULT";
    ResolvedBy["AUTO_RESOLVER"] = "AUTO_RESOLVER";
    ResolvedBy["AUTO_ARCHIVE"] = "AUTO_ARCHIVE";
})(ResolvedBy || (ResolvedBy = {}));
//# sourceMappingURL=ResolvedBy.js.map